<template>
    <nav v-click-outside="closeSubNav" class="navigation-main" aria-label="Main navigation">
        <ul class="navigation-main__list">
            <li
                class="navigation-main__item"
                v-for="(menuItem, index) in navigation"
                :key="index"
                :class="{
                    'is-active': menuItem.active,
                    'navigation-main__item--open': index == menuItemIndex,
                    'navigation-main__item--close': isClosed
                }"
            >
                <button
                    type="button"
                    v-if="menuItem.items.length > 0"
                    @click="showSubItems(menuItem.items, index, menuItem.params)"
                    class="navigation-main__button"
                    :title="menuItem.name"
                >
                    {{ menuItem.name }}
                </button>
                <a v-else :href="menuItem.link" class="navigation-main__button">
                    {{ menuItem.name }}
                </a>
                <div
                    v-if="subMenuItems.length"
                    class="navigation-main__sublist-container"
                    :class="{
                        'navigation-main__sublist-container--right': position.right,
                        'navigation-main__sublist-container--left': position.left
                    }"
                >
                    <ul class="navigation-main__sublist navigation-main__sublist--second">
                        <li
                            class="navigation-main__subitem"
                            v-for="(subItem, index) in subMenuItems"
                            :key="index"
                            :class="{ 'is-subitem-active': subItem.active }"
                        >
                            <button
                                v-if="subItem.items.length"
                                type="button"
                                @click="showSubItemsThirdLevel(subItem.items, index, subItem.name)"
                                class="navigation-main__subbutton"
                                :class="{
                                    'navigation-main__subbutton--active': activeSubButton === index
                                }"
                                href="#"
                                :title="subItem.name"
                            >
                                {{ subItem.name }}
                                <img
                                    class="navigation-main__subbutton-icon"
                                    src="/images/arrow_bold.svg"
                                    width="12"
                                    height="12"
                                />
                            </button>
                            <a
                                v-else
                                class="navigation-main__subbutton"
                                :href="subItem.link"
                                :title="subItem.name"
                            >
                                {{ subItem.name }}
                            </a>
                        </li>
                    </ul>
                    <div class="navigation-main__sublist__content-container">
                        <div v-if="subItemsThirdLevel.length">
                            <h4 class="navigation-main__sublist__content-title">
                                {{ currentSubNavTitle }}
                            </h4>
                            <ul class="navigation-main__sublist navigation-main__sublist--third">
                                <li
                                    class="navigation-main__subitem"
                                    v-for="(item, index) in subItemsThirdLevel"
                                    :key="index"
                                    :class="{ 'is-active': item.active }"
                                >
                                    <a
                                        class="navigation-main__subbutton navigation-main__subbutton--third"
                                        :href="item.link"
                                        :title="item.name"
                                        :class="{ 'is-active': item.active }"
                                    >
                                        {{ item.name }}
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <template v-else>
                            <h4 class="navigation-main__sublist__content__description-title">
                                {{ currentSubMenuContent.SUBMENU__TITLE }}
                            </h4>
                            <figure>
                                <img
                                    v-if="currentSubMenuContent.SUBMENU__IMG"
                                    class="navigation-main__sublist__content__description-img"
                                    :src="currentSubMenuContent.SUBMENU__IMG"
                                    alt=""
                                />
                                <img
                                    v-else
                                    class="navigation-main__sublist__content__description-img"
                                    src="/images/dummy-main-nav.jpg"
                                    alt=""
                                />
                                <figcaption
                                    v-if="currentSubMenuContent.SUBMENU__TEXT"
                                    class="navigation-main__sublist__content__description-info"
                                >
                                    {{ currentSubMenuContent.SUBMENU__TEXT }}
                                </figcaption>
                            </figure>
                        </template>

                        <button
                            type="button"
                            @click="closeSubNav"
                            class="navigation-main__sublist__content-button"
                        >
                            <svg class="navigation-main__sublist__content-icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="26" cy="26" r="13" fill="#F7F7F9"/>
                                <path id="line-first" fill-rule="evenodd" clip-rule="evenodd" d="M11.4037 11.4038C11.7943 11.0133 12.4274 11.0133 12.8179 11.4038L20.5961 19.182C20.9866 19.5725 20.9866 20.2057 20.5961 20.5962C20.2056 20.9867 19.5724 20.9867 19.1819 20.5962L11.4037 12.818C11.0132 12.4275 11.0132 11.7943 11.4037 11.4038Z" fill="#0B2C62"/>
                                <path id="line-second" fill-rule="evenodd" clip-rule="evenodd" d="M20.5961 11.4038C20.9866 11.7943 20.9866 12.4275 20.5961 12.818L12.8179 20.5962C12.4274 20.9867 11.7943 20.9867 11.4037 20.5962C11.0132 20.2057 11.0132 19.5725 11.4037 19.182L19.1819 11.4038C19.5724 11.0133 20.2056 11.0133 20.5961 11.4038Z" fill="#0B2C62"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'navigation-main',
    props: {
        position: {
            type: String,
            default: 'left'
        }
    },
    data () {
        return {
            navigation: this.$root.app.components.navigation.main,
            menuItemIndex: null,
            activeSubButton: -1,
            currentSubNavTitle: '',
            isClosed: false,
            subMenuItems: [],
            subItemsThirdLevel: [],
            currentSubMenuContent: {}
        }
    },
    methods: {
        showSubItems (items, index, params) {
            this.subItemsThirdLevel = []
            this.subMenuItems = items
            this.isClosed = false
            this.currentSubMenuContent = params

            if (this.subMenuItems.length) {
                this.menuItemIndex = index
            } else {
                this.isClosed = true
            }
        },
        showSubItemsThirdLevel (items, index, title) {
            this.activeSubButton = index
            this.subItemsThirdLevel = items
            this.currentSubNavTitle = title
        },
        closeSubNav () {
            this.subMenuItems = []
            this.subItemsThirdLevel = []
            this.isClosed = true
            this.currentSubNavTitle = ''
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
